import PropTypes from "prop-types";
import React from "react";

const InputField = (props) => {
  const {
    className,
    inputClassName,
    label,
    labelClassName,
    onChange,
    value,
    type,
    placeHolder,
    disabled,
    ...extraProps
  } = props;

  return (
    <div className={className}>
      <label className={labelClassName}>
        {label}
      </label>
      <input
        className={inputClassName}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeHolder}
        type={type}
        value={value}
        {...extraProps}
      />
    </div>);
};

export default InputField;

InputField.defaultProps = {
  "className": "",
  "disabled": false,
  "inputClassName": "input-field-input",
  "labelClassName": "input-field-label",
  "placeHolder": "",
  "type": "text",
  "value": ""
};

InputField.propTypes = {
  "className": PropTypes.string.isRequired,
  "disabled": PropTypes.bool,
  "inputClassName": PropTypes.string,
  "label": PropTypes.string.isRequired,
  "labelClassName": PropTypes.string,
  "onChange": PropTypes.func.isRequired,
  "placeHolder": PropTypes.string,
  "type": PropTypes.string,
  "value": PropTypes.string
};
